import { Component } from 'react';
import TabsList from '~/js/views/general/components/tours/data/tabsList';
import ToursItem from '~/js/views/general/components/tours/ToursItem';

export default class ToursList extends Component {
    state = {
        activeTab: TabsList[0],
        topText: ''
    }

    changeTourType = (event, item) =>{
        event.preventDefault();
        this.setState({ activeTab: item });
    }

    render() {
        const { data, resortName } = this.props;
        const { activeTab } = this.state;
        let topText;
        let result = [];

        if( activeTab.type === 'featured') {
            result = data.filter((item)=>{
                return item.isFeatured;
            });
            topText = 'featured tour';
        }else{
            result = data;
            topText = 'tour';
        }
        if(result.length > 1) {
            topText = topText + 's';
        }

        return(
            <div>
                <div className="tours-tabs">
                    {TabsList.map((item, index)=>{
                        return (
                            <a
                                href="#"
                                key={index}
                                className={'tab' + (activeTab.id === item.id ? ' active' : '')}
                                onClick={(e) => this.changeTourType(e, item)}>
                                {item.label}
                            </a>
                        );
                    })}
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="section-intro">{result.length} {topText} <span>at {resortName}</span></div>
                        </div>
                    </div>
                    <div className="wrapper">
                        {result && result.map((item, index)=>{
                            const props = {
                                key: index,
                                eventId: item.eventId,
                                groupId: item.groupId,
                                rstCode: item.rstCode,
                                tourImages: item.tourImages,
                                eventName: item.eventName,
                                rates: item.rates,
                                description: item.description,
                                resortName: resortName
                            };

                            return <ToursItem {...props} />;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
